<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <!-- <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button> -->
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Debitur</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.CustName"
                  placeholder="Debitur Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Debitur No (CIF)</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.CustCode"
                  placeholder="Customer No (CIF)"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.nomor"
                  placeholder="No Kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>

            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">No. Aggrement</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.agreement"
                  placeholder="No Agreement"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="7">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Tgl. Pelunasan</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label class="label-custome">Status Memo</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.status_memo"
              :plain="true"
              :options="statuses_memo"
            ></b-form-select>
            <b-input-group-prepend
              ><label class="label-custome ml-4"
                >No. Memo</label
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.nosurat"></b-form-input>
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="refresh()"
                class="ml-3"
              >
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table-simple
        outlined
        responsive
        hover
        small
        style="font-size: smaller"
        bordered
      >
        <b-thead>
          <b-tr>
            <b-th class="text-center"> No. Kontrak </b-th>
            <b-th class="text-center"> CIF </b-th>
            <b-th class="text-center"> Debitur Name </b-th>
            <b-th class="text-center"> Tgl. Memo </b-th>
            <b-th class="text-center"> No. Memo </b-th>
            <b-th class="text-center"> Periode Pelunasan </b-th>
            <b-th class="text-center">Status Memo </b-th>
            <b-th class="text-center">Ttl. Bayar <br> (Setelah Prepaid)</b-th>
            <b-th class="text-center">Paymemt No.</b-th>
            <b-th class="text-center">Tgl Payment</b-th>
            <b-th class="text-center" style="width:150px;">Prepaid</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(dt,key) in tblData.items" :key="key" :style="(dt.istotal||0)==1?'':''">
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">{{dt.no_kontrak}}</b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">{{dt.CustCode}}</b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">{{dt.CustName}}</b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">{{dt.tglsurat | moment("DD MMM YYYY")}}</b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">{{dt.nosurat}}</b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">{{ dt.tglmulaipelunasan | moment("DD MMM YYYY") }} - {{dt.tglpelunasan | moment("DD MMM YYYY")}}</b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan">
               <span
                v-if="
                  dt.status_memo == 'Approved' ||
                  dt.status_memo == 'Rejected' ||
                  dt.status_memo == 'Send Approval'
                "
                @click="approvalInfoConfirm"
                :class="
                  dt.status_memo == 'Approved'
                    ? 'alert-success navbar-link p-1'
                    : dt.status_memo == 'Send Approval'
                    ? 'alert-info navbar-link p-1'
                    : 'alert-danger navbar-link p-1'
                "
                style="cursor: pointer"
              >
                <span>{{ dt.status_memo }}</span>
              </span>
              <span v-else>
                <span>{{ dt.status_memo }}</span>
              </span>

            </b-td>
            <b-td v-if="dt.rowSpan && (dt.istotal||0)==0" v-bind:rowspan="dt.rowSpan" class="text-right">{{dt.ttlmustpay | numFormat("0,0.00")}}</b-td>
            <b-td v-if="(dt.istotal||0)==0">{{dt.docrefer}}</b-td>
            <b-td v-if="(dt.istotal||0)==0">{{dt.tglpaym | moment("DD MMM YYYY")}}</b-td>
            <b-td v-if="(dt.istotal||0)==1" colspan="10" class="text-center"><b>TOTAL</b></b-td>
            <b-td class="text-right">
              <span v-if="(dt.istotal||0)==1"><b>{{dt.pbb_amt | numFormat("0,0.00")}}</b></span>
              <span v-else>{{dt.pbb_amt | numFormat("0,0.00")}}</span>
            </b-td>
          </b-tr>
        </b-tbody>

      </b-table-simple>
      <!-- <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        :busy="isBusy"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        <template v-slot:cell(tglsurat)="data">{{
          data.item.tglsurat | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(tgl_kontrak)="data">{{
          data.item.tgl_kontrak | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(tglpelunasan)="data"
          >{{ data.item.tglmulaipelunasan | moment("DD MMM YYYY") }} -
          {{ data.item.tglpelunasan | moment("DD MMM YYYY") }}</template
        >
        <template v-slot:cell(ttlpayment_awal)="data">{{
          data.item.ttlpayment_awal | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(ttllatecharge)="data">{{
          data.item.ttllatecharge | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(diskon_amount)="data">{{
          data.item.diskon_amount | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(ttlmustpay)="data">{{
          data.item.ttlmustpay | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(ttlpayment_diskon)="data">{{
          data.item.ttlpayment_diskon | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">{{
          data.item.CONTRACT_PREPAID_AMT | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(prepaid)="data">{{
          data.item.prepaid | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(net_ttlangsuran)="data">{{
          data.item.net_ttlangsuran | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(ttlpayment)="data">{{
          data.item.ttlpayment | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(OS_pokok_due)="data">{{
          data.item.OS_pokok_due | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(ttlprincipalcurrent)="data">{{
          data.item.ttlprincipalcurrent | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(ttlosprincipal_untilmaturity)="data">{{
          data.item.ttlosprincipal_untilmaturity | numFormat("0,0.00")
        }}</template>

        <template v-slot:cell(wo_status)="data">{{
          data.item.wo_status == 1 ? "WO" : "Normal"
        }}</template>
        <template v-slot:cell(status_memo)="data">
          <span
            v-if="
              data.item.status_memo == 'Approved' ||
              data.item.status_memo == 'Rejected' ||
              data.item.status_memo == 'Send Approval'
            "
            @click="approvalInfoConfirm"
            :class="
              data.item.status_memo == 'Approved'
                ? 'alert-success navbar-link p-1'
                : data.item.status_memo == 'Send Approval'
                ? 'alert-info navbar-link p-1'
                : 'alert-danger navbar-link p-1'
            "
            style="cursor: pointer"
          >
            <span>{{ data.item.status_memo }}</span>
          </span>
          <span v-else>
            <span>{{ data.item.status_memo }}</span>
          </span>
        </template>
        <template v-slot:cell(paid_date)="data">
          <span
            v-if="
              data.item.status_memo == 'Approved' ||
              data.item.status_memo == 'Rejected'
            "
          >
            <span> - </span>
          </span>
          <span v-else>
            <span v-if="data.item.ispaid == 1">{{
              data.item.paid_date | moment("DD MMM YYYY")
            }}</span>
          </span>
        </template>

        <template v-slot:cell(modified_by)="data">{{
          data.item.modified_by ? data.item.modified_by : "-"
        }}</template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table> -->
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                  @change="data"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
            @change="data"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="showApprovalConfirm"
      header-bg-variant="primary"
      title="Approval Form"
      size="lg"
      :centered="true"
      hide-footer
    >
      <b-row>
        <b-col md="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 140px"
                >Nomor Memo</label
              ></b-input-group-prepend
            >
            <b-form-input v-model="model.nosurat" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="4">
          <b-input-group>
            <b-input-group-prepend
              ><label>Tanggal Memo</label></b-input-group-prepend
            >
            <b-form-input v-model="model.tglsurat" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >No. Kontrak</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >No. Aggrement</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.no_agreement" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >Nama Debitur</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.CustName" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >Tanggal Pelunasan</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.tglpelunasan" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px">Perihal</label></b-input-group-prepend
        >
        <b-form-input v-model="model.perihal" readonly></b-form-input>
      </b-input-group>

      <div v-if="this.model.send2wf == 1">
        <label class="mt-3"><h6>Workflow process history</h6></label>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="220px">Assign Date</th>
                <th width="220px">Assign To</th>
                <!-- <th width="220px">State</th> -->
                <th width="120px">Action Take</th>
                <th>Comment</th>
                <th width="120px">Complete Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                <td>
                  {{ row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>{{ row.crewnik }} | {{ row.crewname }}</td>
                <!-- <td>{{row.state}}</td> -->
                <td>
                  {{ row.actiontake }}
                  <!-- <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p> -->
                </td>
                <td>{{ row.message }}</td>
                <td>
                  <span v-if="row.completeddate">{{
                    row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")
                  }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="subtotal"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="printApproval"
            ><i class="fa fa-print"></i> Print Approval</b-button
          >
          <b-button
            variant="danger"
            class="ml-1"
            @click="showApprovalcancelConfirm = true"
          >
            <i class="fa fa-undo"></i> Cancel Approval</b-button
          >
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showApprovalConfirm = false"
          >
            <i class="fa fa-close"></i> Close</b-button
          >
        </b-row>
      </div>
      <div no-body v-else>
        <label>Add Attachment</label>
        <b-form-file
          v-model="file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <div class="mt-3">
          Selected file: <strong>{{ file ? file.name : "" }}</strong>
        </div>
        <b-row class="justify-content-center mt-1" v-if="showConfirmNoFile">
          <label style="width: 260px !important"
            >Send without attachment, are you sure?</label
          >
          <b-form-radio-group v-model="confirmNoFile" class="ml-1">
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-row>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="approval"
            ><i class="fa fa-paper-plane"></i> Send to Workflow</b-button
          >
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showApprovalConfirm = false"
          >
            <i class="fa fa-close"></i> Close</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="showApprovalcancelConfirm"
      title="Remove from workflow Approval Process?"
      :centered="true"
      @ok="approvalUndo"
    >
      <p class="mb-1">
        The selected a row of data will be removed from Workflow?
      </p>
    </b-modal>
    <b-modal
      id="modal-prevent-closing"
      v-model="showExpiredConfirm"
      title="Expired Memo"
      :centered="true"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleExpiredOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <p class="mb-1">The selected a row of data will be expired?</p>
        <b-form-group
          label="Note"
          label-for="name-input"
          invalid-feedback="Note is required"
          :state="!$v.frmDtExpired.expired_note.$error"
        >
          <b-form-input
            id="name-input"
            v-model="frmDtExpired.expired_note"
            :state="!$v.frmDtExpired.expired_note.$error"
            required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      v-model="showApprovalInfo"
      header-bg-variant="primary"
      title="Workflow Approval History"
      size="lg"
      :centered="true"
      hide-footer
    >
      <div v-if="this.model.send2wf == 1">
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="220px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="120px">Action Take</th>
                <th>Comment</th>
                <th width="120px">Complete Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                <td>
                  {{ row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>{{ row.crewnik }} | {{ row.crewname }}</td>
                <td>
                  {{ row.actiontake }}
                  <!-- <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p> -->
                </td>
                <td>{{ row.actiontake }} alasan: {{ row.message }}</td>
                <td>
                  <span v-if="row.completeddate">{{
                    row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")
                  }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="subtotal"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showSppConfirm"
      header-bg-variant="primary"
      title="SPP Form"
      size="md"
      :centered="true"
      hide-footer
    >
      <div v-if="this.model.issuccess == 1">
        <div>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 140px">Nomor SPP</label>
                </b-input-group-prepend>
                <b-input
                  v-model="model.nosurat_spp"
                  :state="!$v.model.nosurat_spp.$error"
                />
              </b-input-group>
            </b-col>
            <!-- :state="!$v.model.nosurat_spp.$error" -->
            <!-- :disabled="model.nosurat_spp" -->
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 140px">Tanggal SPP</label>
                </b-input-group-prepend>
                <b-input
                  type="date"
                  v-model="model.tglsurat_spp"
                  :state="!$v.model.tglsurat_spp.$error"
                />
              </b-input-group>
            </b-col>
          </b-row>
          <!-- :state="!$v.model.tglsurat_spp.$error" -->
          <!-- :disabled="model.tglsurat_spp" -->
          <hr />
          <b-row class="justify-content-center mt-1">
            <!-- <b-button variant="primary" @click="printPDFSPP" v-if="model.nosurat_spp"><i class="fa fa-print"></i> Print SPP</b-button>
                  <b-button variant="primary" @click="submitSPP" v-else><i class="fa fa-paper-plane"></i> Submit & Print SPP</b-button> -->
            <b-button variant="primary" @click="submitSPP"
              ><i class="fa fa-paper-plane"></i> Submit</b-button
            >
            <b-button
              variant="secondary"
              class="ml-2"
              @click="showSppConfirm = false"
            >
              <i class="fa fa-close"></i> Close</b-button
            >
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.label-custome {
  max-width: 110px;
}
</style>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import task from "../../apis/task";
import pelunasan from "../../apis/pelunasanpinjaman";
import crud from "../../apis/crud";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();
export default {
  components: { Loading },
  mixins: [validationMixin],
  validations: {
    frmDtExpired: { expired_note: { required } },
    model: {
      nosurat_spp: { required },
      tglsurat_spp: { required },
    },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      // start print
      isLoading: false,
      showReport: false,
      reportUrl: "",
      // end print
      showApprovalConfirm: false,
      showApprovalInfo: false,
      approvalHistory: [],
      showSppConfirm: false,
      file: null,
      confirmNoFile: false,
      showConfirmNoFile: "",
      showApprovalcancelConfirm: false,
      showExpiredConfirm: false,
      model: {},
      frmDtExpired: { expired_note: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        items:[],
        tglsurat1: moment().startOf("month").format("YYYY-MM-DD"),
        tglsurat2: moment().format("YYYY-MM-DD"),
        tgl1: moment().startOf("month").format("YYYY-MM-DD"),
        tgl2: moment().endOf("month").format("YYYY-MM-DD"),
        sortBy: "",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status_memo: "",
        nosurat: "",
        nomor: "",
        agreement: "",
        CustName: "",
        CustCode: "",
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "kol-1", text: "KOL-1" },
        { value: "kol-2", text: "KOL-2" },
        { value: "kol-3", text: "KOL-3" },
        { value: "kol-4", text: "KOL-4" },
        { value: "kol-5", text: "KOL-5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        { value: "LIV", text: "Live" },
        { value: "ICP", text: "Incomplete Payment" },
        { value: "RRD", text: "Ready Release Document" },
      ],
      statuses_memo: [
        { value: "", text: "--- ALL ---" },
        { value: "Send Approval", text: "Send Approval" },
        { value: "Approved", text: "Approved" },
        { value: "Rejected", text: "Rejected" },
        { value: "Expired", text: "Expired" },
        { value: "Paid", text: "Paid" },
      ],
    };
  },
  computed: {
    invalidFrmDtExpired() {
      this.$v.frmDtExpired.$touch();
      return this.$v.frmDtExpired.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "tglsurat",
          label: "Tgl. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "tipepelunasan",
          label: "Jenis Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tglpelunasan",
          label: "Tgl. Pelunasan",
          thStyle: "min-width:200px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttlpayment_awal",
          label: "Sisa Pinjaman",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "ttlpayment_diskon",
          label: "Ttl. Diskon",
          thStyle: "width:140px",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "ttlpayment",
          label: "Sisa Pinjaman Net",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "prepaid",
          label: "Ttl. Prepaid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "ttlmustpay",
          label: "Ttl. Bayar (Setelah Prepaid)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "ttlosprincipal_untilmaturity",
          label: "Total OS Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "paid_date",
          label: "Tgl. Settlement",
          thStyle: "width:160px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "cessie_collectability",
          label: "Cessie Collectability",
          thStyle: "min-width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    // this.isBusy = true;
    // this.data();
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    this.data();
  },
  methods: {
    resetModal() {
      this.frmDtExpired.expired_note = "";
    },
    handleExpiredOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (this.invalidFrmDtExpired) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        return;
      }
      // Push the name to submitted names
      // this.submittedNames.push(this.name)
      this.expireddata();
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    async expireddata() {
      try {
        if (this.model.pelunasankey) {
          this.isLoading = true;
          this.model.expired_note = this.frmDtExpired.expired_note;
          const data = await pelunasan.expired(this.model);
          this.isLoading = false;
          toastr.success(`No Memo : ${data.nosurat}, has been expired.`);
        } else {
          toastr.warn("Please select a row that want to expired");
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        this.isLoading = true;
        const list = await pelunasan.paymentmemopelunasan(this.tblData);
        this.tblData.items=list || [];
        this.isLoading = false;
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isLoading = false;
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.data();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.CustCode = "";
      this.tblData.CustName = "";
      this.tblData.collectability = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nomor = "";
      this.tblData.agreement = "";
      this.tblData.status_memo = "";
      this.tblData.nosurat = "";
      this.tblData.tglsurat1 = "";
      this.tblData.tglsurat2 = "";
      this.refresh();
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await pelunasan.exportxlsPayment(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async printPDFMemoPelunasan() {
      if (this.model.pelunasankey) {
        this.isLoading = true;
        try {
          this.reportUrl = await pelunasan.printPDFMemoPelunasan(
            this.model.pelunasankey
          );
          this.isLoading = false;
          this.showReport = true;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to print");
      }
    },

    async printPDFSPP() {
      if (this.model.pelunasankey && this.model.issuccess) {
        this.isLoading = true;
        try {
          this.reportUrl = await pelunasan.printPDFSPP(this.model.pelunasankey);
          this.isLoading = false;
          this.showReport = true;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to print");
      }
    },

    async edit() {
      if (this.model.pelunasankey) {
        router.push({
          name: "loan.pelunasanmemofrm",
          params: { pelunasankey: this.model.pelunasankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    async followupRejected() {
      if (
        this.model.pelunasankey &&
        this.model.iscomplete == 1 &&
        this.model.isreject == 1
      ) {
        router.push({
          name: "loan.followuprejectedfrm",
          params: { pelunasankey: this.model.pelunasankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },

    approvalConfirm: async function () {
      if (this.model.pelunasankey) {
        this.model.tglpelunasan = this.model.tglpelunasan
          ? moment(this.model.tglpelunasan).format("DD MMM YYYY")
          : "";
        this.model.tglsurat = this.model.tglsurat
          ? moment(this.model.tglsurat).format("DD MMM YYYY")
          : "";

        if (this.model.send2wf == 1) {
          try {
            const data = await task.approvalhistory({
              key: this.model.pelunasankey,
            });
            this.approvalHistory = data;
          } catch (error) {
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
        this.model.requestdate = this.model.requestdate
          ? moment(this.model.requestdate).format("YYYY-MM-DD")
          : "";
        this.showApprovalConfirm = true;
      } else {
        toastr.warn(
          "Please select a row that want to be sent to workflow Approval!"
        );
      }
    },
    approval: async function (evt) {
      evt.preventDefault();
      try {
        const formData = new FormData();
        if (!this.file) {
          if (this.confirmNoFile == false) {
            toastr.info("Send without attachment, are you sure?");
            this.showConfirmNoFile = true;
            return;
          }
        } else {
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
        }
        formData.append("tablekey", this.model.pelunasankey);
        this.showApprovalConfirm = false;
        this.isLoading = true;
        const resp = await pelunasan.approval(formData);
        this.model.send2wf = 1;
        this.refresh();
        this.isLoading = false;
        if (resp.message) {
          toastr.warn(resp.message, "warning", 10000);
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    approvalInfoConfirm: async function (record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      setTimeout(() => {
        this.approvalInfo();
      }, 500);
    },

    approvalInfo: async function () {
      if (this.model.pelunasankey) {
        if (this.model.send2wf == 1) {
          try {
            this.showApprovalInfo = true;
            const data = await task.approvalhistory({
              key: this.model.pelunasankey,
            });
            this.approvalHistory = data;
          } catch (error) {
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      }
    },

    sppConfirm: async function () {
      if (this.model.pelunasankey && this.model.issuccess == 1) {
        if (!this.model.nosurat_spp) {
          this.model.tglsurat_spp = this.model.tglsurat_spp
            ? moment(this.model.tglsurat_spp).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD");
          this.showSppConfirm = true;
        } else {
          this.printPDFSPP();
        }
      } else {
        toastr.warn(
          "Please select a row that want to be sent to workflow Approval!"
        );
      }
    },
    submitSPP: async function (evt) {
      evt.preventDefault();
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.showSppConfirm = false;
          this.isLoading = true;
          const respSPP = await pelunasan.spp(this.model);
          this.isLoading = false;
          if (respSPP.message) {
            toastr.warn(respSPP.message, "warning", 10000);
          } else {
            toastr.success("Submit SPP successfully.");
            this.printPDFSPP();
            this.refresh();
          }
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    approvalUndo: async function () {
      this.isLoading = true;
      try {
        await pelunasan.approvalUndo(this.model);
        this.model.send2wf = 0;
        this.showApprovalConfirm = false;
        this.refresh();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    printApproval: async function () {
      if (this.model.pelunasankey) {
        this.isLoading = true;
        try {
          this.reportUrl = await task.approvalprint({
            key: this.model.pelunasankey,
          });
          this.showReport = true;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>